{
  "delete_schedule_version": {
    "title": "Supprimer le calendrier disciplinaire",
    "message": "La suppression de {{ scheduleVersionName }} supprimera également ses événements. Voulez-vous continuer ?"
  },
  "show_schedule": "Afficher le calendrier",
  "delete_schedule": {
    "title": "Supprimer le calendrier des compétitions",
    "message": "La suppression de {{ scheduleVersionName }} supprimera également ses calendriers et événements disciplinaires. Voulez-vous continuer ?"
  },
  "toasts": {
    "scheduled_items_start_end_times_affected": "Les heures de début et de fin de certains éléments programmés peuvent avoir été affectées"
  },
  "other": {
    "no_items_based_on_selection": {
      "Discipline": "Aucun élément à afficher en fonction de la sélection de la discipline.",
      "Day": "Aucun article à afficher en fonction de la sélection du lieu."
    }
  },
  "errorMessages": {
    "scheduled_item_must_be_within_session": "L'élément programmé doit se situer dans les heures de début et de fin de la session",
    "must_end_after_start_time": "L'événement doit se terminer après l'heure de début"
  },
  "session_form": {
    "medal_header": "Médailles et cérémonies",
    "medal_ceremony": "cérémonie de remise des médailles",
    "includes_medal_ceremony": "Comprend la cérémonie de remise des médailles"
  },
  "validation": {
    "startTimeValid": "L'heure de début doit être exprimée en secondes, minutes et heures",
    "startTimeWithinParent": "L'heure de début doit être postérieure à l'heure de début des parents",
    "endTimeBeforeStartTime": "L'heure de début doit être antérieure à l'heure de fin",
    "endTimeValid": "L'heure de fin doit être composée de secondes, de minutes et d'heures",
    "endTimeWithinParent": "L'heure de fin doit être antérieure à l'heure de fin des parents"
  },
  "activity": {
    "titleDeleteUnsaved": "Supprimer une ligne non enregistrée",
    "descriptionDeleteUnsaved": "Êtes-vous sûr de vouloir supprimer cette nouvelle ligne ?"
  },
  "divisions": "Divisions",
  "upload_event_blocks": {
    "title": "Télécharger le contenu du calendrier",
    "calendar_level": "Niveau du calendrier",
    "delete_existing": "Supprimer les éléments existants",
    "delete_existing_confirmation_title": "Supprimer les éléments existants",
    "delete_existing_confirmation_description": "Vous avez sélectionné « Supprimer les articles existants ». Cela supprimera tous les événements du calendrier selon la version de calendrier que vous avez sélectionnée et les remplacera par les valeurs CSV que vous avez fournies. Cela ne peut pas être annulé. Désirez-vous continuer ?",
    "csv_validation_errors_subtitle": "Erreurs de validation CSV"
  },
  "exports": {
    "title": "Options d'exportation",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "message": "Veuillez choisir une option pour exporter",
    "downloadTitle": "Télécharger",
    "downloadDescription": "L'export ODF sera téléchargé sur votre ordinateur",
    "publishedDescription": "L'export ODF sera publié sur {{ exportDestinationName }}",
    "notAvailable": "Non disponible"
  },
  "key": {
    "title": "Clé pour programmer les couleurs des blocs"
  },
  "data_fields": {
    "event_unit_description": "Unité événementielle",
    "event_name": "Événement",
    "competition_pahse": "Phase de compétition",
    "gender": "Genre",
    "medal_type": "Type de médaille",
    "ticketing_code": "Code de billetterie",
    "ticketed": "Billetté",
    "discipline": "La discipline",
    "session_code": "Code de session",
    "session_style": "Style de session",
    "session_type": "Type de séance",
    "venue_code": "Code du lieu",
    "Event": "Événement",
    "Phase": "Phase",
    "Event unit": "Unité événementielle",
    "Division": "Division",
    "Owner": "Propriétaire",
    "multi_selector": {
      "all": {
        "Discipline": "Toutes les disciplines"
      },
      "none": {
        "Discipline": "Aucune discipline"
      },
      "x_selected": {
        "Discipline": "{{ count }} disciplines sélectionnées"
      }
    },
    "view_by_day_label": {
      "Discipline": "Journée (Discipline)"
    }
  },
  "scheduleDoesntExist": {
    "noPermission": "Aucun calendrier n'a été établi pour ce projet. Vous devrez demander à un utilisateur disposant de privilèges d'administrateur de le faire pour vous.",
    "createTitle": "Configurer le calendrier de ce projet",
    "createDescription": "Aucun calendrier n'a été établi pour ce projet. Configurez le calendrier à l'aide des paramètres ci-dessous. Si vous ne savez pas comment configurer le calendrier, contactez le support :"
  },
  "venueEdit": {
    "parentVenue": "Lieu pour les parents",
    "venueLocationType": "Type d'emplacement du lieu",
    "topLevelVenueName": "Niveau supérieur",
    "tryDeleteParent": "Supprimez les références d'identification des parents à cette ligne avant de supprimer",
    "tryEditParent": "{{ count }} sites font référence à celui-ci comme étant leur parent. Supprimez ces références avant de continuer."
  },
  "sidebar": {
    "upload": "Télécharger des blocs d'événements",
    "deleteListItemMessage": "Êtes-vous sûr de vouloir supprimer tous les éléments de la liste ?",
    "deleteListItemTitle": "Supprimer les éléments de la liste"
  }
}